import React from "react";

// Assets
import avatar from "../../Assets/contactusAvatar.svg";
import nameIcon from "../../Assets/formNameIcon.svg";
import phoneIcon from "../../Assets/formPhoneIcon.svg";
import mailIcon from "../../Assets/formMailIcon.svg";

import line from "../../Assets/lines.svg";
import youtube from "../../Assets/youtubelogo.svg";
import inlogo from "../../Assets/in.svg";
import insta from "../../Assets/insta.svg";
import fb from "../../Assets/fb.svg";

function ContactUsSection() {
  return (
    <div className="contactUsSection">
      <div className="contactUsSection_Avatar">
        <img src={avatar} alt="Conact Us Avatar" />
      </div>
      <div className="contactUsSection_Block">
        <div className="contactUsSection_Block2">
          <div className="formTitle">Connect With Us</div>
          <div className="formInstruction">
            connect with us by sending your email address.
            <br />
            we contact you to ask your requirements
          </div>
          <div className="formBlock">
            <form className="form">
              <input
                type="text"
                className="enterName"
                placeholder="Enter Your Name"
                style={{ backgroundImage: `url(${nameIcon})`, backgroundRepeat: "no-repeat", backgroundPosition: "left" }}
                required
              />
              <input
                type="text"
                className="enterMNumber"
                placeholder="Enter Your Mobile Number"
                style={{ backgroundImage: `url(${phoneIcon})`, backgroundRepeat: "no-repeat", backgroundPosition: "left" }}
                required
              />
              <input
                type="text"
                className="enterEmail"
                placeholder="Enter Your Email Address"
                style={{ backgroundImage: `url(${mailIcon})`, backgroundRepeat: "no-repeat", backgroundPosition: "left" }}
                required
              />
              <div className="btnDiv">
                <button type="submit" className="formbtn">
                  SEND
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="socialinks">
        <div>
          <img src={youtube} alt="3D Model" />
        </div>
        <div>
          <img src={fb} alt="3D Model" />
        </div>
        <div>
          <img src={insta} alt="3D Model" />
        </div>
        <div>
          <img src={inlogo} alt="3D Model" />
        </div>
      </div>

      <div className="line">
        <img src={line} alt="3D Model" />
      </div>
    </div>
  );
}

export default ContactUsSection;
